export const EXAMPLE_BUILDS = [
  {
    id: "starter",
    name: "The Starter",
    target: "1080p high refresh",
    for: "Fortnite, Valorant, Rocket League, Minecraft",
    img: "/img/gaming-setup.jpg",
    parts: [
      ["CPU", "6-core AMD Ryzen 5 / Intel Core i5"],
      ["Graphics", "RTX 5060 / RX 9060 XT class"],
      ["Memory", "16GB DDR5"],
      ["Storage", "1TB NVMe SSD"],
      ["Power", "650W 80+ Bronze"],
      ["Case", "Airflow case with RGB fans"],
    ],
  },
  {
    id: "contender",
    name: "The Contender",
    target: "1440p ultra",
    for: "Warzone, Fortnite, EA FC, Cyberpunk at 1440p",
    img: "/img/gaming-ram.jpg",
    parts: [
      ["CPU", "8-core AMD Ryzen 7 / Intel Core i7"],
      ["Graphics", "RTX 5070 / RX 9070 class"],
      ["Memory", "32GB DDR5"],
      ["Storage", "2TB NVMe SSD"],
      ["Power", "750W 80+ Gold"],
      ["Cooling", "240mm AIO or tower cooler"],
    ],
  },
  {
    id: "flagship",
    name: "The Flagship",
    target: "4K & streaming",
    for: "4K gaming, streaming and video editing",
    img: "/img/gaming-tower.jpg",
    parts: [
      ["CPU", "AMD Ryzen 7 X3D / Intel Core Ultra 7"],
      ["Graphics", "RTX 5080 class or above"],
      ["Memory", "32–64GB DDR5"],
      ["Storage", "2TB + 2TB NVMe SSD"],
      ["Power", "1000W 80+ Gold"],
      ["Cooling", "360mm AIO"],
    ],
  },
];

export const BUDGETS = ["Under £600", "£600 – £900", "£900 – £1,300", "£1,300 – £2,000", "£2,000+", "Not sure yet"];
export const RESOLUTIONS = ["1080p", "1440p", "4K", "Not sure"];
export const USES = ["Gaming", "Streaming", "Video editing", "Work / study", "VR"];
export const EXTRAS = ["Monitor", "Keyboard & mouse", "Headset", "Wi-Fi", "Windows licence"];
